import '../Card.css'
import '../../App.css';

function BrakeAccumulators({ tkd, data }) {
  return (
    <>
      {data.map(({ value, acc, blinkClass, className }, index) => (
        <div className={`${className} tooltip`} key={index}>
          <img className={value < 600 ? blinkClass : ''} src={acc} alt="" />
          {tkd !== "---" && <span className="tooltiptext">{value}</span>}
          
        </div>
      ))}
    </>
  );
}

export default BrakeAccumulators;
